var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHireIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_3195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.01068 30.6666H25.344",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 49.3333V45.3333C41.3333 44.9797 41.4738 44.6406 41.7239 44.3905C41.9739 44.1405 42.3131 44 42.6667 44H61.3333C61.687 44 62.0261 44.1405 62.2762 44.3905C62.5262 44.6406 62.6667 44.9797 62.6667 45.3333V56C62.6667 56.3536 62.5262 56.6928 62.2762 56.9428C62.0261 57.1929 61.687 57.3333 61.3333 57.3333H57.3333",
    fill: "#E8DFFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3333 49.3333V45.3333C41.3333 44.9797 41.4738 44.6406 41.7239 44.3905C41.9739 44.1405 42.3131 44 42.6667 44H61.3333C61.687 44 62.0261 44.1405 62.2762 44.3905C62.5262 44.6406 62.6667 44.9797 62.6667 45.3333V56C62.6667 56.3536 62.5262 56.6928 62.2762 56.9428C62.0261 57.1929 61.687 57.3333 61.3333 57.3333H57.3333",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0107 49.3334H37.344C36.6076 49.3334 36.0107 49.9303 36.0107 50.6667V61.3334C36.0107 62.0698 36.6076 62.6667 37.344 62.6667H56.0107C56.7471 62.6667 57.344 62.0698 57.344 61.3334V50.6667C57.344 49.9303 56.7471 49.3334 56.0107 49.3334Z",
    fill: "#E8DFFB",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 55.3334C46.7985 55.3334 46.9274 55.3725 47.037 55.4457C47.1467 55.519 47.2321 55.6231 47.2826 55.7449C47.333 55.8667 47.3462 56.0008 47.3205 56.1301C47.2948 56.2594 47.2313 56.3782 47.1381 56.4714C47.0448 56.5647 46.926 56.6282 46.7967 56.6539C46.6674 56.6796 46.5334 56.6664 46.4115 56.616C46.2897 56.5655 46.1856 56.4801 46.1124 56.3704C46.0391 56.2608 46 56.1319 46 56C46 55.8232 46.0702 55.6537 46.1953 55.5286C46.3203 55.4036 46.4899 55.3334 46.6667 55.3334Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 21.3333L39.4667 13.8853C39.9667 13.3854 40.6449 13.1045 41.352 13.1045C42.0591 13.1045 42.7373 13.3854 43.2373 13.8853L44.8 15.448C45.3001 15.9479 45.9782 16.2287 46.6853 16.2287C47.3924 16.2287 48.0706 15.9479 48.5707 15.448L62.6667 1.33331",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0107 1.33331H62.6773V12",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 62.6667C19.8899 62.6667 23.6204 61.1214 26.3709 58.3709C29.1214 55.6204 30.6667 51.8898 30.6667 48C30.6667 39.8987 21.3333 30.6667 21.3333 30.6667L26.5333 23.2533C26.79 22.8865 26.9201 22.4461 26.9039 21.9987C26.8877 21.5513 26.7261 21.1214 26.4436 20.7741C26.1612 20.4268 25.7732 20.1811 25.3385 20.0741C24.9038 19.9671 24.4461 20.0048 24.0347 20.1813C23.2405 20.5217 22.3625 20.6162 21.514 20.4527C20.6655 20.2892 19.8855 19.8751 19.2747 19.264L18.552 18.5413C17.8779 17.8675 16.9638 17.489 16.0107 17.489C15.0575 17.489 14.1434 17.8675 13.4693 18.5413L12.7467 19.264C12.1369 19.8724 11.3593 20.2848 10.5136 20.4483C9.66784 20.6117 8.79255 20.5188 8.00001 20.1813C7.58801 19.9995 7.12775 19.9578 6.68979 20.0626C6.25182 20.1675 5.8603 20.413 5.57523 20.7616C5.29016 21.1102 5.12727 21.5427 5.11152 21.9928C5.09576 22.4428 5.22802 22.8856 5.48801 23.2533L10.6667 30.6667C10.6667 30.6667 1.33334 39.8987 1.33334 48C1.33334 51.8898 2.87858 55.6204 5.62911 58.3709C8.37964 61.1214 12.1102 62.6667 16 62.6667Z",
    fill: "#D5DEFF",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01068 30.6666H28.0107",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0107 52.0027V54.6694",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0107 38.6693V41.336",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 52H18.6667C19.3739 52 20.0522 51.7191 20.5523 51.219C21.0524 50.7189 21.3333 50.0406 21.3333 49.3334C21.3333 48.6261 21.0524 47.9479 20.5523 47.4478C20.0522 46.9477 19.3739 46.6667 18.6667 46.6667H13.3333C12.6261 46.6667 11.9478 46.3858 11.4477 45.8857C10.9476 45.3856 10.6667 44.7073 10.6667 44C10.6667 43.2928 10.9476 42.6145 11.4477 42.1144C11.9478 41.6143 12.6261 41.3334 13.3333 41.3334H21.3333",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_3195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireIcon1);
export default __webpack_public_path__ + "static/media/hireIcon1.add4ee2bf484e5ba057a9b9d098867e7.svg";
export { ForwardRef as ReactComponent };